module.exports = __webpack_public_path__ + "img/shipin2.9f39a7ac.jpg";